const debug = () => () => module.exports

module.exports = debug
module.exports.disable = () => {}
module.exports.enable = () => {}
